import { useAppContext } from '../../../Services/AppContext';

export const getIsLatam = () => {
	let isLatam = false;
	switch (useAppContext().globalTemplate) {
		case 'peru':
		case 'ecuador':
		case 'mexico':
		case 'colombia':
			isLatam = true;
	}
	return isLatam;
};
